import { v4 as uuid } from 'uuid';

import type { TargetEntry } from '../../../common/Wizard/common/targeting';
import type { SurveyTargeting } from '../../../../domain/Surveys/Survey/Survey';

type Callbacks = {
  onEditRule: (entry: TargetEntry) => void;
  onAddRule: (newRule: SurveyTargeting, error?: string) => void;
  onRemoveRule: (entry: TargetEntry) => void;
};

export const useEditingCallbacks = (
  targeting: TargetEntry[] | undefined,
  onTargetingChange: (targeting: TargetEntry[]) => void,
): Callbacks => {
  const onEditRule = (editedEntry: TargetEntry) => {
    if (targeting === undefined) return;
    const newEntries = targeting.map((entry) => {
      return editedEntry.id === entry.id ? editedEntry : { ...entry };
    });
    onTargetingChange(newEntries);
  };

  const onAddRule = (newTarget: SurveyTargeting, error?: string) => {
    if (targeting === undefined) return;
    const newEntries = targeting.map((entry) => ({ ...entry }));
    newEntries.push({ id: uuid(), target: newTarget, error, isNew: true });
    onTargetingChange(newEntries);
  };

  const onRemoveRule = (toRemove: TargetEntry) => {
    if (targeting === undefined) return;
    const newEntries = targeting
      .filter((target) => target.id !== toRemove.id)
      .map((entry) => ({ ...entry }));
    onTargetingChange(newEntries);
  };

  return { onEditRule, onAddRule, onRemoveRule };
};
